const paths = {
  root: '/',
  authenticated: {
    welcome: '/welcome',
    billOfLading: '/bill-of-lading/$billOfLadingId',
    customers: '/customers',
    customerProductMatches: '/customer-product-matches',
    supplierProductMatches: '/supplier-product-matches',
    discounts: '/discounts',
    // purchaseOrders: '/purchase-orders',
    inventory: {
      products: '/inventory/products',
      product: '/inventory/products/$productId',
    },
    salesOrders: '/sales-orders',
    // Legacy sales orders pages, moved off the unversioned path when OMS v3
    // took it over. Non-enhanced orgs are redirected here from /sales-orders.
    salesOrdersV2: '/sales-orders-v2',
    salesOrderV2: '/sales-orders-v2/$salesOrderId',
    invoiceDiff: '/invoices/$invoiceId1/$invoiceId2',
    accountsPayable: {
      commandCenter: '/accounts-payable/command-center',
      metrics: '/accounts-payable/metrics',
      /** @deprecated use metrics */
      throughput: '/accounts-payable/throughput',
      exceptionRules: '/accounts-payable/exception-rules',
      exceptionRuleSetNew: '/accounts-payable/exception-rules/new',
      exceptionRuleSet: '/accounts-payable/exception-rules/$ruleSetId',
      exceptionRuleSetEdit: '/accounts-payable/exception-rules/$ruleSetId/edit',
      invoices: '/accounts-payable/invoices',
      invoice: '/accounts-payable/invoices/$invoiceId',
      purchaseOrders: '/accounts-payable/purchase-orders',
      purchaseOrder: '/accounts-payable/purchase-orders/$purchaseOrderId',
      payments: '/accounts-payable/payments',
      payment: '/accounts-payable/payments/$paymentId',
      bulkPayments: '/accounts-payable/bulk-payments',
    },
    accountsReceivable: {
      agingReport: '/accounts-receivable/aging-report',
      reconciliation: '/accounts-receivable/reconciliation',
      summary: '/accounts-receivable/summary',
      cashMetrics: '/accounts-receivable/cash-metrics',
      cashDashboard: '/accounts-receivable/cash-dashboard',
      ingestedSalesOrders: '/accounts-receivable/ingested-sales-orders',
      ingestedSalesOrder:
        '/accounts-receivable/ingested-sales-orders/$salesOrderId',
      invoices: '/accounts-receivable/invoices',
      invoice: '/accounts-receivable/invoices/$arInvoiceId',
      reports: '/accounts-receivable/reports',
      savedReport: '/accounts-receivable/reports/saved/$savedReportId',
      collections: '/accounts-receivable/collections',
      customerProfile: '/accounts-receivable/collections/$customerId',
    },
    rebates: {
      submitted: '/rebates/submitted',
      analytics: '/rebates/analytics',
      audits: '/rebates/audits',
      auditDetail: '/rebates/audits/$agreementId',
      debitors: '/rebates/debtors',
      reporting: '/rebates/reporting',
      reconciliation: '/rebates/reconciliation',
      supplierCollections: '/rebates/supplier-collections/$supplierId',
      contracts: '/rebates/contracts',
      agreements: '/rebates/agreements',
      agreement: '/rebates/agreements/:id',
      calculationAudit: '/rebates/agreements/$agreementId/audit',
      uploadData: '/rebates/upload-data',
      uploadDataAI: '/rebates/upload-data/ai',
      uploadDataManual: '/rebates/upload-data/manual',
      uploadDataJobs: '/rebates/upload-data/jobs',
      uploadDataRun: '/rebates/upload-data/run/$sessionId',
      convertWorkflow: '/rebates/convert',
      enableConvert: '/rebates/enable-convert',
      tierProximity: '/rebates/tier-proximity',
      reports: '/rebates/reports',
      divisionRebateSummary: '/rebates/reports/division-summary',
      supplierTagSummary: '/rebates/reports/supplier-tag-summary',
      dailyEarningsPYE: '/rebates/reports/daily-earnings-pye',
      monthlyTrending: '/rebates/reports/monthly-trending',
      supplierPaymentTerms: '/rebates/reports/supplier-payment-terms',
      profitability: '/rebates/reports/profitability',
      supplierYoY: '/rebates/reports/supplier-yoy',
      dataExport: '/rebates/data-export',
      settings: '/rebates/settings',
      supplierReportedAmounts: '/rebates/supplier-reported-amounts/$supplierId',
    },
    shipping: '/shipping',
    shipAndDebit: {
      dashboard: '/ship-and-debit',
      staged844: '/ship-and-debit/staged',
      stagedInternal: '/ship-and-debit/staged-internal',
      deleted: '/ship-and-debit/no-claim-transactions',
      vdm: '/ship-and-debit/vdm',
      transactions: '/ship-and-debit/844-submissions',
      responses849: '/ship-and-debit/849-responses',
      response849Detail: '/ship-and-debit/849-responses/$responseId',
      search844: '/ship-and-debit/search-rexel-files',
      companyLocations: '/ship-and-debit/company-locations',
    },
    procurement: {
      suppliers: '/suppliers',
      supplier: '/supplier/$supplierId',
      inquiries: '/inquiries',
      inquiry: '/inquiries/$inquiryId',
      purchaseOrders: '/procurement/purchase-orders',
      purchaseOrder: '/procurement/purchase-order/$purchaseOrderId',
      priceSheetDashboard: '/price-sheet-dashboard',
      priceSheetInbox: '/price-sheet-inbox',
      as400RawData: '/procurement/as400-raw-data',
      millableReview: '/procurement/millable-review',
      freightOptions: '/procurement/freight-options',
      overrides: '/procurement/demand-forecasting/overrides',
      demandForecasting: {
        root: '/procurement/demand-forecasting',
        general: '/procurement/demand-forecasting/general',
        overrides: '/procurement/demand-forecasting/overrides',
        leadTime: '/procurement/demand-forecasting/lead-time',
        surplus: '/procurement/demand-forecasting/surplus',
        outlierRules: '/procurement/demand-forecasting/outlier-rules',
        salesHistoryTransfers:
          '/procurement/demand-forecasting/sales-history-transfers',
        runs: '/procurement/demand-forecasting/runs',
      },
      forecastSummary: '/procurement/forecast/summary',
      forecastRunHistory: '/procurement/demand-forecasting/runs',
    },
    pricing: {
      root: '/pricing',
      new: '/pricing/new',
      detail: '/pricing/spas/$spaId',
      spaRecords: '/pricing/spa-records',
      spaRecordDetail: '/pricing/spa-records/$spaId',
      masterlist: '/pricing/masterlist',
    },
    companies: '/companies',
    company: '/companies/$companyId',
    finance: {
      accounts: '/finance/accounts',
      balanceSheet: '/finance/balance-sheet',
      incomeStatement: '/finance/income-statement',
      ledgerRules: '/finance/ledger-rules',
    },
    businessIntelligence: '/business-intelligence',
    orderMetrics: '/order-metrics',
    reports: '/reports',
    workflows: {
      list: '/workflows',
      runs: '/workflows/runs',
      groups: '/workflows/groups',
      groupCreate: '/workflows/groups/new',
      groupDetail: '/workflows/groups/$workflowGroupId',
      templates: '/workflows/templates',
      scheduledReruns: '/workflows/scheduled-reruns',
      create: '/workflows/new',
      // URL identity is the Workflow (lineage). Without a version segment the
      // view shows the pinned definition; `/v/$versionNumber` shows a specific
      // version. Bookmarks against `workflow` follow the pin through time.
      workflow: '/workflows/$workflowId',
      workflowVersion: '/workflows/$workflowId/v/$versionNumber',
      run: '/workflows/$workflowId/runs/$workflowRunId',
    },
    guardrailPolicies: '/guardrail-policies',
    backgroundAgents: {
      list: '/agents',
      templates: '/agents/templates',
      procedures: '/agents/procedures',
      procedureNew: '/agents/procedures/new',
      procedureImportReview: '/agents/procedures/imports/$importId',
      procedureDetail: '/agents/procedures/$id',
      procedureVersionDetail: '/agents/procedures/$id/v/$versionNumber',
      procedureVersions: '/agents/procedures/$id/versions',
      mockUiStudio: '/evals/mocks/studio',
      definition: '/agents/$agentDefinitionId',
      definitionTools: '/agents/$agentDefinitionId/tools',
      definitionProcedures: '/agents/$agentDefinitionId/procedures',
      definitionTaskManagement: '/agents/$agentDefinitionId/task-management',
      definitionResources: '/agents/$agentDefinitionId/resources',
      definitionPermissions: '/agents/$agentDefinitionId/permissions',
      definitionVersions: '/agents/$agentDefinitionId/versions',
      definitionEvals: '/agents/$agentDefinitionId/evals',
      definitionSessions: '/agents/$agentDefinitionId/sessions',
      definitionSessionDetail:
        '/agents/$agentDefinitionId/sessions/$agentRunId',
    },
    settings: {
      organization: '/settings/organization',
      controlPlaneLink: '/settings/control-plane-link',
      user: '/settings/user',
      userSecurity: '/settings/user/security',
      userOutOfOffice: '/settings/user/out-of-office',
      userNavigation: '/settings/user/navigation',
      userNotifications: '/settings/user/notifications',
      userLanguage: '/settings/user/language',
      userKeyboardShortcuts: '/settings/user/keyboard-shortcuts',
      userEmailSignature: '/settings/user/email-signature',
      externalApis: '/settings/organization/external-apis',
      emailTemplates: '/settings/organization/email-templates',
      // Accepts an org template uuid or a `builtin:<key>` ref.
      emailTemplate: '/settings/organization/email-templates/$templateId',
    },
    tenant: '/settings/tenant',
    inboundEmails: '/inbound-emails',
    // temp/demo links:
    spreadsheets: { new: '/spreadsheets/new' },
    traceability: '/traceability',
    traceabilityV2: '/traceability-v2',
    warehouses: '/warehouses',
    customerCollections: '/customer-collections/$customerId',
    feedbackTriage: '/feedback-triage',
    documents: '/documents',
    document: '/documents/$documentId',
    famousEDI: '/famous-edi',
    famousEDIShipments: '/famous-edi-shipments',
    famousEDIShipment: '/famous-edi-shipments/$shipmentId',
    ediTextMessages: '/edi-text-messages',
    divisions: '/divisions',
    division: '/divisions/$divisionId',
    maintenance: {
      root: '/admin/maintenance',
      backfills: '/admin/maintenance/backfills',
      indexes: '/admin/maintenance/indexes',
      reconciliation: '/admin/maintenance/reconciliation',
      largeTables: '/admin/maintenance/large-tables',
      workerScaling: '/admin/maintenance/worker-scaling',
    },
    featureFlags: '/ff_overrides',
    historicalImport: '/admin/historical-import',
    rexelMonitoring: '/rexel-monitoring',
    memoryBankNotes: '/memory-bank-notes',
    sharedLinks: '/shared-links',
    integrations: {
      list: '/integrations',
      detail: '/integrations/$integrationKey',
    },
    auditReports: '/audit-reports',
    inbox: '/inbox',
    notifications: '/notifications',
    agentMonitor: {
      list: '/agent-monitor',
      detail: '/agent-monitor/$agentDefinitionId',
    },
    mockUiStudio: '/mock-ui-studio',
    // Unified live-capture Studio (AI-340 P4): one walkthrough of a real prod site → SOP + mock +
    // eval golden. Lives alongside the Mock UI Studio under the evals home.
    unifiedStudio: '/evals/mocks/unified-studio',
    // Evals home (AI-385) — relocated from /agent-evals + /agents/mock-ui, opened from the user menu.
    evals: {
      root: '/evals',
      mocks: '/evals/mocks',
      studio: '/evals/mocks/studio',
      unifiedStudio: '/evals/mocks/unified-studio',
      run: '/evals/runs/$runId',
    },
    tools: {
      fileExtraction: '/tools/file-extraction',
    },
    // Pitch pages for features a user can't reach yet. Anyone can open these,
    // and the "alert me" CTA on each is how we measure demand.
    featurePreviews: {
      agents: '/preview/agents',
      tasks: '/preview/tasks',
      tools: '/preview/tools',
      workflows: '/preview/workflows',
    },
  },
  unauthenticated: {
    status: '/status',
  },
} as const;

export default paths;
